import { LocalStorageConsts } from 'client/util/Constants';
import { createLocaleLoader } from 'client/util/i18nUtils';
import LocalStorageService from 'client/util/LocalStorageService';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const getLocalePreference = () => LocalStorageService.getItem(LocalStorageConsts.locale);
const setLocalePreference = (locale) => LocalStorageService
  .setItem(LocalStorageConsts.locale, locale);

const i18n = new VueI18n({
  locale: getLocalePreference() || 'en-US',
  fallbackLocale: 'en-US',
  messages: {},
});

export default i18n;

/**
 * @param {string} locale
 */
export const setLocale = (locale) => {
  setLocalePreference(locale);
  i18n.locale = locale;
};

export const loadAdminPortalLocales = async () => {
  let locales = require.context('client/lang/', true, /[A-Za-z0-9-_]+\.json$/i, 'lazy');
  const loadLocales = createLocaleLoader(locales, i18n);

  await loadLocales(locales);

  if (module.hot) {
    module.hot.accept(locales.id, () => {
      // do NOT try to refactor the require.context() arguments into variables
      // webpack processes the arguments statically and is not able to determine what a variable's
      // value will be at runtime. Duplicating the arguments is necessary here
      locales = require.context('client/lang/', true, /[A-Za-z0-9-_]+\.json$/i, 'lazy');
      loadLocales(locales);
    });
  }
};
